var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcnGoogleLens = function SvgIcnGoogleLens(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.234 8.381c0-1.184.963-2.147 2.147-2.147h1.835V4H8.38A4.386 4.386 0 0 0 4 8.381v1.838h2.234V8.38ZM15.619 6.234c1.184 0 2.146.963 2.146 2.147v1.838H20V8.38A4.386 4.386 0 0 0 15.619 4h-1.835v2.234h1.835ZM8.381 17.766a2.149 2.149 0 0 1-2.147-2.147v-1.832H4v1.832A4.387 4.387 0 0 0 8.381 20h1.838v-2.234H8.38ZM12 15.103a3.103 3.103 0 1 0 0-6.206 3.103 3.103 0 0 0 0 6.206ZM19.11 17.35a1.77 1.77 0 1 1-3.539 0 1.77 1.77 0 0 1 3.538 0Z",
    fill: "#292525"
  })));
};
export default SvgIcnGoogleLens;